<template>
  <div class="step step--career-known">
    <button-back @back="back"></button-back>
    <div class="text-center">
      <div align-h="center">
        <div xl="4" lg="6" md="8" sm="12">
          <div class="mb-4">
            <icon-briefcase class="step__icon" />
            <h2>Do you have a specific career in mind?</h2>
          </div>
          <div class="step__buttons">
            <div class="button-radio btn btn-primary btn-block">
              <input id="career-known-yes" type="radio" v-model="user.careerKnown" value="yes"> <label for="career-known-yes">Yes</label>
            </div>
            <div class="button-radio btn btn-primary btn-block">
              <input id="career-known-no" type="radio" v-model="user.careerKnown" value="no"> <label for="career-known-no">No</label>
            </div>
          </div>
        </div>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBack from '../buttons/Back.vue'
import Disclaimer from '../Disclaimer.vue'
import IconBriefcase from '../animatedicons/IconBriefcase.vue'

export default {
  name: 'CareerKnownStep',
  props: {
    user: Object
  },
  components: {
    IconBriefcase,
    Disclaimer,
    ButtonBack,
  },
  methods: {
    back: function () {
      this.$emit('back');
    }
  },
  mounted: function () {
    this.user.careerKnown = null;
  },
  watch: {
    'user.careerKnown': function () {
      if (this.user.careerKnown) {
        this.$emit('completed');
      }
    },
  }
}
</script>

<style scoped>
</style>
